export default __webpack_public_path__ + "static/media/G01LI.aa171cf1.jpg";